var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lck-action-button',_vm._g({attrs:{"displayCheckIcon":_vm.displayCheckIcon,"settings":_vm.action,"content":_vm.content}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }